<template>
  <div
    class="forum-create-comment-button control-el d-inline"
    v-if="canCommentOnThoughts(topic) || canCommentAfterLogin(topic)"
  >
    <button class="btn btn-sm btn-primary" @click="openCreateComment">Antworten</button>
    <OverlayPanel
      v-if="!isLoggedIn"
      ref="loginOP"
      :showCloseIcon="true"
      :dismissable="true"
      appendTo="body"
      class="wdw-widgets"
    >
      <p>Um einen neuen Beitrag zu erstellen, müssen Sie sich zunächst einloggen!</p>
      <Login :domainid="domainid" />
    </OverlayPanel>
  </div>
</template>

<script>
import { ref, computed, toRef } from 'vue';

// stores
import { userStore } from '@/store/user-store';
import { domainStore } from '@/store/domain-store';

// components
import OverlayPanel from 'primevue/overlaypanel';
import Login from '@/components/user/Login.vue';

// composables
import useTopicConfig from '@/composables/topic/useTopicConfig';

export default {
  name: 'forum-create-comment-button',
  props: {
    thought: {
      type: Object,
      required: true,
    },
    topic: {
      type: Object,
      required: true,
    },
  },
  emit: ['create-comment'],

  setup(props, context) {
    const thought = toRef(props, 'thought');
    const topic = toRef(props, 'topic');
    const loginOP = ref();
    const { canCommentOnThoughts, canCommentAfterLogin } = useTopicConfig();

    //
    //-----------------COMPUTED------------------
    //
    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });
    const domainid = computed(() => {
      return domainStore.getState().domainid;
    });

    //
    //-----------------METHODS------------------
    //

    function openCreateComment(event) {
      //Check if user is logged in
      if (canCommentOnThoughts(topic.value)) {
        context.emit('create-comment', {
          thought: thought.value,
          topic: topic.value,
        });
      } else if (canCommentAfterLogin(topic.value)) {
        loginOP.value.show(event);
      } else {
        console.error('error: cannot create comment, but button visible/clicked');
      }
    }

    return {
      // REFS
      loginOP,

      // COMPUTED
      domainid,
      isLoggedIn,

      // METHODS
      openCreateComment,
      canCommentOnThoughts,
      canCommentAfterLogin,
    };
  },

  components: {
    OverlayPanel,
    Login,
  },
};
</script>
